import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import { DigisubservicesService } from '../services/digisubservices.service';
@Component({
  selector: 'app-all-rep-book-commission',
  // standalone: true,
  // imports: [],
  templateUrl: './all-rep-book-commission.component.html',
  styleUrl: './all-rep-book-commission.component.scss'
})
export class AllRepBookCommissionComponent {
   startDate = '';
  endDate = '';
  office_rep_name = '';
  rep_name = '';
  book_seller_name = '';
  reportType = 'All Rep Book Commission';

  currentDate = new Date();

  filterData: any[] = [];
  groupedData: any[] = [];
  grandTotal = {
  total_invoice: 0,
  total_received: 0,
  total_commission: 0,
  total_paid: 0,
  total_unpaid: 0
};


  constructor(
    private dialogRef: MatDialogRef<AllRepBookCommissionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) {}

 ngOnInit(): void {
  debugger

  this.startDate = this.data.startDate ?? '';
  this.endDate = this.data.endDate ?? '';

  this.rep_name = this.data.rep_name ?? '';
  this.office_rep_name = this.data.office_rep_name ?? '';

  this.book_seller_name = this.data.book_seller_name ?? '';

  this.getCommissionData();
}


  // ================= API CALL =================
  getCommissionData(): void {
    const req = {
      start_date: this.startDate,
      end_date: this.endDate,
      office_rep_name: this.office_rep_name,
      rep_name: this.rep_name,
      book_seller_name: this.book_seller_name
    };

    this.service. getAllRepBookCommission2(req).subscribe({
      next: (res: any) => {
        this.filterData = res || [];
        // this.applyClientSideFilters();
        this.groupCommissionData();
      },
      error: (err) => console.error("Error loading report:", err)
    });
  }

  // ================= CLIENT-SIDE FILTERING =================
  // applyClientSideFilters(): void {
  //   let filteredData = [...this.filterData];

  //   // Filter by Office Rep Name
  //   if (this.office_rep_name && this.office_rep_name.trim() !== '') {
  //     filteredData = filteredData.filter(item => 
  //       item.office_rep_name && 
  //       item.office_rep_name.toLowerCase().includes(this.office_rep_name.toLowerCase())
  //     );
  //   }

  //   // Filter by Rep Name
  //   if (this.rep_name && this.rep_name.trim() !== '') {
  //     filteredData = filteredData.filter(item => 
  //       item.rep_name && 
  //       item.rep_name.toLowerCase().includes(this.rep_name.toLowerCase())
  //     );
  //   }

  //   // Filter by Book Seller Name
  //   if (this.book_seller_name && this.book_seller_name.trim() !== '') {
  //     filteredData = filteredData.filter(item => 
  //       item.receiver_name && 
  //       item.receiver_name.toLowerCase().includes(this.book_seller_name.toLowerCase())
  //     );
  //   }

  //   this.filterData = filteredData;
  // }

  // ================= GROUPING LOGIC =================
  groupCommissionData(): void {
    const officeMap = new Map();

    this.filterData.forEach(item => {
      const office = item.office_rep_name || 'Unknown Office';
      const rep = item.rep_name || 'Unknown Representative';

      // OFFICE
      if (!officeMap.has(office)) {
        officeMap.set(office, {
          office_rep_name: office,
          repGroups: new Map(),
          total_invoice: 0,
          total_received: 0,
          total_commission: 0,
          total_paid: 0,
          total_unpaid: 0
        });
      }

      const officeObj = officeMap.get(office);

      // REP
      if (!officeObj.repGroups.has(rep)) {
        officeObj.repGroups.set(rep, {
          rep_name: rep,
          records: [],
          repTotal_invoice: 0,
          repTotal_received: 0,
          repTotal_commission: 0,
          repTotal_paid: 0,
          repTotal_unpaid: 0
        });
      }

      const repObj = officeObj.repGroups.get(rep);

      // RECORD
      repObj.records.push(item);

      // REP TOTAL
      repObj.repTotal_invoice += Number(item.invoice_total) || 0;
      repObj.repTotal_received += Number(item.invoice_received_amt) || 0;
      repObj.repTotal_commission += Number(item.rep_commission_amt) || 0;
      repObj.repTotal_paid += Number(item.received_amt) || 0;
      repObj.repTotal_unpaid += Number(item.remaining_amt) || 0;

      // OFFICE TOTAL
      officeObj.total_invoice += Number(item.invoice_total) || 0;
      officeObj.total_received += Number(item.invoice_received_amt) || 0;
      officeObj.total_commission += Number(item.rep_commission_amt) || 0;
      officeObj.total_paid += Number(item.received_amt) || 0;
      officeObj.total_unpaid += Number(item.remaining_amt) || 0;

      this.grandTotal.total_invoice += Number(item.invoice_total) || 0;
this.grandTotal.total_received += Number(item.invoice_received_amt) || 0;
this.grandTotal.total_commission += Number(item.rep_commission_amt) || 0;
this.grandTotal.total_paid += Number(item.received_amt) || 0;
this.grandTotal.total_unpaid += Number(item.remaining_amt) || 0;

    });

    // Convert Map → Array
    this.groupedData = Array.from(officeMap.values()).map(o => ({
      ...o,
      repGroups: Array.from(o.repGroups.values())
    }));
  }

  // ================= PRINT =================
printPageA4(): void {
  const printContent = document.getElementById('print-section');
  if (!printContent) return;

  const WindowPrt = window.open('', '', 'width=900,height=1200');

  WindowPrt!.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Book Credit Note Report</title>
        <style>

          /* ===== ENSURE COLORS & BORDERS PRINT ===== */
          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
          }

          /* ===== A4 PORTRAIT PAGE ===== */
          @page {
            size: A4 portrait;
            margin: 8mm 6mm 8mm 15mm; /* top right bottom left */
          }

          body {
            margin: 0;
            font-family: Arial, sans-serif;
            font-size: 11px;
            color: #000;
            -webkit-font-smoothing: none;
          }

          /* ===== TABLE ===== */
          table {
            width: 100%;
            border-collapse: collapse;
            border: 1px solid #000;   /* outer border */
          }

          th, td {
            border: 1px solid #000;
            padding: 5px 6px;
            vertical-align: middle;
            white-space: nowrap;
            text-align: left;
          }

          thead {
            display: table-header-group;
          }

          tr {
            page-break-inside: avoid;
          }

          /* ===== FOOTER ===== */
          tfoot {
            display: table-row-group;
            font-weight: bold;
          }

          /* ===== PRINT ONLY ===== */
          @media print {
            .noPrint { display: none !important; }
          }

        </style>
      </head>

      <body>
        ${printContent.innerHTML}
      </body>
    </html>
  `);

  WindowPrt!.document.close();
  WindowPrt!.focus();

  setTimeout(() => {
    WindowPrt!.print();
    WindowPrt!.close();
  }, 500);
}





  // ================= EXPORT EXCEL =================
  exportExcel(filename: string): void {
    const element = document.getElementById('print-section');
    const ws = XLSX.utils.table_to_sheet(element);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Report');
    XLSX.writeFile(wb, `${filename}.xlsx`);
  }
}